import React from 'react';
import { useNav } from '../../hx/useNav';
import { useTranslation } from '../../hx/useTranslation';
import CxSearcher from '../../cx/CxSearcher';
import CxCheck from '../../cx/CxCheck';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxDat from '../../fx/FxDat';
import * as FxTable from '../../fx/FxTable';
import * as FxFetch from "../../fx/FxFetch";
import GxForm from '../../gx/GxForm';
import { StoreSlsDoc, StoreSlsLst } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import CxSnackbar from '../../cx/CxSnackbar';
import CxIconButton from '../../cx/CxIconButton';

const MxSlsDocFormLots = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navBack }] = useNav();

  const [storeSlsLst] = useSessionStorage('StoreSlsLst', StoreSlsLst);
  const [storeSlsDoc, setStoreSlsDoc] = useSessionStorage('StoreSlsDoc', StoreSlsDoc);

  let r_form = React.useRef(null);
  let r_arControls = React.useRef([]);
  const rf_boIncludeExpired = React.useRef(null);

  const r_snack_required = React.useRef(null);
  const r_snack_warning = React.useRef(null);

  const formSaveCustom = () => {
    try {
      if (!isRequired()) {
        for (let index = 0; index < r_arControls.current.length; index++) {
          const ctl = r_arControls.current[index];
          if (ctl) {
            let txLotCode = ctl.getRow().original.txLotCode;
            let dtLotExpr = FxDat.toIso(ctl.getRow().original.dtLotExpr);
            storeSlsDoc.arItems[ctl.getItemIndex()].txLotCode = txLotCode;
            storeSlsDoc.arItems[ctl.getItemIndex()].dtLotExpr = dtLotExpr;
          }
        }
        setStoreSlsDoc({ ...storeSlsDoc });
        navBack();
      }
    } catch (error) {
      FxLog.errorx('MxSlsDocFormLots.formSaveCustom', error)
    }
  }

  // Modificamos esta función para que acepte el valor del check como parámetro
  const getSearcherFilter = (inPs, boIncludeExpired) => {
    if (boIncludeExpired) {
      return `n_pur_invoice_item.inPs='${inPs}'`;
    } else {
      return `n_pur_invoice_item.inPs='${inPs}' and n_pur_invoice_item.dtLotExpr>date(now())`;
    }
  }

  // Nueva función que se ejecuta al pinchar el check
  const handleCheckClick = (v) => {
    try {
      // 1. Obtenemos el valor actual del check
      let boIncludeExpired = v;
      
      // 2. Iteramos sobre todos los componentes montados en el array de referencias
      for (let i = 0; i < r_arControls.current.length; i++) {
        const ctl = r_arControls.current[i];
        if (ctl) {
          // 3. Necesitamos el inPs original para regenerar el filtro, lo sacamos del store
          let idx = ctl.getItemIndex();
          let item = storeSlsDoc.arItems.find(x => x.idx === idx);
          
          if (item) {
            // 4. Generamos el nuevo filtro y usamos la función expuesta por tu componente
            let newFilter = getSearcherFilter(item.inPs, boIncludeExpired);
            ctl.setFilter(newFilter);
          }
        }
      }
    } catch (error) {
      FxLog.errorx('MxSlsDocFormLots.handleCheckClick', error);
    }
  }

  const isRequired = () => {
    let rv = false;
    try {
      for (let index = r_arControls.current.length - 1; index >= 0; index--) {
        const ctl = r_arControls.current[index];
        if (ctl && ctl.getIsRequired()) {
          let label = ctl.getLabel();
          r_snack_required.current.setVal(trans('field.required') + ": " + label);
          r_snack_required.current.setOpen(true);
          rv = true;
        }
      }
    } catch (error) {
      FxLog.errorx('MxSlsDocFormLots.isRequired', error)
    }
    return rv;
  };

  const lotSelected = (row) => {
    FxLog.infox('MxSlsDocFormLots.lotSelected', '...row:', row);
    let inPs = row.original.inPs;
    let txLotCode = row.original.txLotCode;

    let obRecord = {};
    obRecord['inPs'] = inPs;
    Promise.all([FxFetch.doJsonX(`pss/lot_alert/load`, obRecord)]).then((arResult) => {
      if (arResult[0]) {
        showLotAlert(arResult[0], txLotCode); 
      }
    });
  };

  const showLotAlert = (arLotAlerts, myValue) => {
    let txLotCode = myValue;
    let arFiltered = [];
    let strAlerts = '';

    if (arLotAlerts && arLotAlerts.length > 0) {
      arFiltered = arLotAlerts.filter(obAlert => (obAlert.txLotCode === txLotCode && (obAlert.txUse === 'x' || obAlert.txUse === 's' )));

      if (arFiltered.length > 0) {
        strAlerts = arFiltered
          .map(obAlert => obAlert.txLotAlert || '')
          .filter(txLotAlert => txLotAlert !== '')
          .join(' | ');
      }
    }

    if (strAlerts !== '') {
      r_snack_warning.current.setValAndOpen(strAlerts);
    }
  }

  return (
    <div>
      <GxForm
        moduleName={`${trans('field.sales')}: ${trans('field.lots')}`}
        xref={r_form}
        toolbarBackground={storeSlsLst.listTypeBackground}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <CxIconButton type="accept" classType="ibs_iconbutton_toolbar" onClick={() => formSaveCustom()} />
          </div>
        }
      >

        <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
          <CxCheck 
            xref={rf_boIncludeExpired} 
            label={trans('field.include_x', 'field.expired_p').toUpperCase()} 
            fontSize={10}
            //width={150}
            onClick={(v) => handleCheckClick(v)} // Asignamos nuestra nueva función iteradora aquí
          />
        </div>

        {storeSlsDoc.arItems.filter(item => item.txLotCode === '**pending**').map((item, i) => (
          <CxSearcher 
            key={item.idx} // Volvemos a la key normal
            itemIndex={item.idx}
            xref={(element) => r_arControls.current[item.idx] = element}
            label={item.txPs + ' (' + item.nuQuantity + ')'}
            url="sls/docitem/lots"
            filter={getSearcherFilter(item.inPs, false)} // Valor inicial (asumiendo check en false)
            col_id="inPurInvoiceItem"
            col_tx="txLotCode"
            refColors={[ 'table_cell_color_brown|' + trans('field.expired'), 'table_cell_color_red|' + trans('field.sold_out') ]}
            onSelection={lotSelected}
            columns={[
              { id: "0", Header: "ID", accessor: "inPurInvoiceItem", show: false },
              { id: "1", Header: trans('field.lot'), accessor: "txLotCode", width: '35%' },
              { id: "2", Header: trans('field.expiration'), accessor: row => FxTable.cellToLocalDate(row["dtLotExpr"]), width: '35%' },
              { id: "3", Header: trans('field.quantity'), accessor: "nuQuantity", width: '30%', align: 'center' },
              { id: "W", Header: "_expired", accessor: row => FxDat.isExpired(row["dtLotExpr"]), show: false },
              { id: "R", Header: "_sold_out", accessor: row => Boolean(row["nuQuantity"] < 1), show: false },
            ]}
            required
            width="100%"
          />
        ))}

      </GxForm>

      <CxSnackbar xref={r_snack_required} severity="error" />
      <CxSnackbar xref={r_snack_warning} severity="warning" />

    </div>
  );
}

export default MxSlsDocFormLots;